import { gql } from '@apollo/client'
import { CONFIGURATION_QUERY } from '../../graphql.js'
import { useQuery } from '@apollo/client/react'

const CONFIGURATION = gql(CONFIGURATION_QUERY)

export default function ConfigValue({ configKey, defaultValue, html }) {
  console.log('ConfigValue rendered: ', configKey, 'default: ', defaultValue)
  const { loading, error, data } = useQuery(CONFIGURATION, { variables: { key: configKey } })

  if (error) return `Error! ${error.message}`
  if (loading) return 'Loading...'
  if (data.configuration && data.configuration.value) {
    if (html) {
      return <div dangerouslySetInnerHTML={{ __html: data.configuration.value }} />
    } else {
      return data.configuration.value
    }
  } else {
    return defaultValue
  }
}
